import axios from "axios";
import swal from "sweetalert2";
import parser from "html-react-parser";

import { useState, useEffect } from "react";
import { Link, useParams } from "react-router-dom";
import { globalState, accessTokenKey, normalizeExternalUrl, baseUrl } from "../utils/config";

import Loader from "./layouts/Loader";
import imagePlaceholder from "../assets/img/user-placeholder.png";

function UserProfile() {
    const { id } = useParams();
    const [loading, setLoading] = useState(false);
    const [user, setUser] = useState(null);
    const [cv, setCv] = useState(null);
    const [projects, setProjects] = useState([]);
    const [posts, setPosts] = useState([]);

    async function fetch() {
        setLoading(true);

        try {
            const timeZone = Intl.DateTimeFormat().resolvedOptions().timeZone;
            const formData = new FormData();
            formData.append("id", id);
            formData.append("time_zone", timeZone);

            const response = await axios.post(
                baseUrl + "/api/users/find",
                formData,
                {
                    headers: {
                        Authorization: "Bearer " + localStorage.getItem(accessTokenKey)
                    }
                }
            );

            if (response.data.status == "success") {
                setUser(response.data.user);
                setCv(response.data.cv);
                setProjects(response.data.projects);
                setPosts(response.data.posts);
            } else {
                swal.fire("Error", response.data.message, "error");
            }
        } catch (exp) {
            console.log(exp.message);
        } finally {
            setLoading(false);
        }
    }

    async function toggleLike(event, id) {
        const node = event.currentTarget;
        node.setAttribute("disabled", "disabled");

        try {
            const formData = new FormData();
            formData.append("id", id);
            formData.append("type", "post");

            const response = await axios.post(
                baseUrl + "/api/bookmarks/toggle",
                formData,
                {
                    headers: {
                        Authorization: "Bearer " + localStorage.getItem(accessTokenKey)
                    }
                }
            );

            if (response.data.status == "success") {
                const temp = [ ...posts ];
                for (let a = 0; a < temp.length; a++) {
                    if (temp[a].id == id) {
                        temp[a].is_bookmarked = !temp[a].is_bookmarked;
                        break;
                    }
                }
                setPosts(temp);
            } else {
                swal.fire("Error", response.data.message, "error");
            }
        } catch (exp) {
            console.log(exp.message);
        } finally {
            node.removeAttribute("disabled");
        }
    }

    useEffect(function () {
        fetch();
    }, []);

    const styles = {
        ...(user?.cover_photo ? {
            coverPhoto: {
                backgroundImage: "url(" + user?.cover_photo + ")",
                backgroundRepeat: "no-repeat",
                backgroundPosition: "top"
            }
        } : {}),
        about: {
            fontSize: "20px"
        },
        postMedia: {
            width: "100px",
            borderRadius: "5px"
        }
    };

    return (
        <>
            {/*<div className="container-xxl py-5 bg-dark page-header mb-5"
                style={ styles.coverPhoto }>
                <div className="container my-5 pt-5 pb-4">
                    <h1 className="display-3 text-white mb-3 animated slideInDown">{ user?.name }</h1>
                    <nav aria-label="breadcrumb">
                        <ol className="breadcrumb text-uppercase">
                            <li className="breadcrumb-item"><Link to="/">Home</Link></li>
                            <li className="breadcrumb-item"><Link to="/find-talent">Find talent</Link></li>
                            <li className="breadcrumb-item text-white active" aria-current="page">{ user?.name }</li>
                        </ol>
                    </nav>
                </div>
            </div>*/}

            { loading && (
                <div className="row mt-5 mb-5">
                    <div className="col-md-12 text-center">
                        <Loader />
                    </div>
                </div>
            ) }

            <div className="profile-header">
                { user != null && user.cover_photo ? (
                    <img src={ user?.cover_photo } alt={ user?.name }
                        className="cover" />
                ) : (
                    <img src={ imagePlaceholder } alt={ user?.name }
                        className="cover" />
                ) }
                
                <div className="overlay"></div>

                <div className="profile-info">
                    { user != null && user.profile_image ? (
                        <img src={ user?.profile_image } alt={ user?.name }
                            className="logo" />
                    ) : (
                        <img src={ imagePlaceholder } alt={ user?.name } className="logo" />
                    ) }

                    <h1>{ user?.name }</h1>
                </div>
            </div>

            <div className="container-xxl py-1">
                <div className="container">

                    <div className="profile-container">
                        <div className="row">
                            <div className="col-md-8">
                                <div className="header">
                                    {/*<img className="profile-img"
                                        src={ user?.profile_image }
                                        alt={ user?.name }
                                        onError={ function (event) {
                                            event.target.remove();
                                        } } />*/}

                                    <div className="user-info">
                                        <h2>{ user?.name || "" }</h2>
                                        <p style={ styles.about } className="mt-2 mb-2">{ user?.about || "" }</p>
                                        <p className="mb-2">{ user?.currently_working == "" ? "" : ((user?.currently_working || "") + " - ") } { user?.currently_located || "" }</p>
                                        <p>{ user?.email }</p>
                                    </div>
                                </div>
                            </div>

                            <div className="col-md-4">
                                { cv != null && (
                                    <a href={ cv.path } target="_blank" className="btn btn-primary">Download CV</a> 
                                ) }

                                { user != null && (
                                    <button type="button" className="btn btn-info text-white ms-2"
                                        onClick={ function () {
                                            const temp = [ ...globalState.state.chats ];

                                            if (temp.length >= 3) {
                                                swal.fire("Error", "You can chat with 3 users at-a-time.", "error");
                                                return;
                                            }

                                            let flag = false;
                                            for (let a = 0; a < temp.length; a++) {
                                                if (temp[a].id == user.id) {
                                                    flag = true;
                                                    break;
                                                }
                                            }

                                            if (!flag) {
                                                temp.push({
                                                    id: user.id,
                                                    name: user.name,
                                                    profileImage: user.profile_image,
                                                    type: user.type,
                                                    hasFetchedMessages: false,
                                                    messages: [],
                                                    page: user.page || 1,
                                                    fetching: false
                                                });
                                                globalState.setState({
                                                    chats: temp
                                                });
                                            }
                                        } }>Chat</button>
                                ) }
                            </div>
                        </div>

                        { user?.summary != "" && (
                            <div className="section">
                                <h3>Summary</h3>

                                <div>{ parser(user?.summary || "") }</div>
                            </div>
                        ) }

                        { posts.length > 0 && (
                            <>
                                <div className="section mb-0">
                                    <h3 className="mb-0">Posts</h3>
                                </div>

                                { posts.map(function (post, index) {
                                    return (
                                        <div className="row" key={ `post-${ post.id }` }>
                                            <div className="col-md-12">
                                                <div className="post">
                                                    <div className="post-header">
                                                        <img className="avatar" src={ post.user.profile_image }
                                                            alt={ post.user.name } />
                                                        
                                                        <div className="post-meta">
                                                            <span className="username">{ post.user.name }</span>
                                                            <span className="timestamp">{ post.created_at_relative }</span>
                                                        </div>
                                                    </div>

                                                    <div className="post-content">
                                                        { post.caption }

                                                        { post.files.map(function (file, fileIndex) {
                                                            return (
                                                                <div key={ `post-${ post.id }-file-${ fileIndex} ` }
                                                                    className="mt-3">
                                                                    { file.type.includes("image") ? (
                                                                        <img src={ file.path } style={ styles.postMedia } />
                                                                    ) : file.type.includes("image") && (
                                                                        <video src={ file.path } style={ styles.postMedia }></video>
                                                                    ) }
                                                                </div>
                                                            );
                                                        }) }
                                                    </div>

                                                    <div className="post-footer">
                                                        <button className={ "like-btn " + (post.is_bookmarked ? "active" : "") } onClick={ function (event) {
                                                            toggleLike(event, post.id);
                                                        } }>
                                                            Like &nbsp; <i className="fa fa-heart"></i>
                                                        </button>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    );
                                }) }
                            </>
                        ) }

                        { projects.length > 0 && (
                            <>
                                <div className="section mb-0">
                                    <h3 className="mb-0">Projects</h3>
                                </div>

                                <div className="projects mt-4">
                                    { projects.map(function (project, index) {
                                        return (
                                            <div className="projects__item" key={ `project-${ index }` }>
                                                { project.files.map(function (file, fileIndex) {
                                                    return (
                                                        <div key={ `file-${ fileIndex }` } className="display-contents">
                                                            { file.type.includes("image") ? (
                                                                <img src={ file.path } className="projects__image" />
                                                            ) : file.type.includes("video") && (
                                                                <video src={ file.path } className="projects__image"></video>
                                                            ) }
                                                        </div>
                                                    );
                                                }) }
                                                
                                                <div className="projects__content">
                                                    <h3 className="projects__title">
                                                        { project.url ? (
                                                            <a href={ normalizeExternalUrl(project.url) } target="_blank" className="projects__link">{ project.title }</a>
                                                        ) : (
                                                            <>
                                                                { project.title }
                                                            </>
                                                        ) }
                                                    </h3>

                                                    <p className="projects__time">⏱️ Time Taken: { project.time_took }</p>
                                                    <p className="projects__description mb-0">
                                                        { parser(project.description || "") }
                                                    </p>
                                                </div>
                                            </div>
                                        );
                                    }) }
                                </div>
                            </>
                        ) }

                        { (user?.desired_job_title != ""
                            || user?.desired_salary != ""
                            || user?.desired_cities != ""
                            || user?.desired_skills != "") && (
                            <div className="job-preferences mt-5">
                                <h2 className="job-preferences__heading">Job Preferences</h2>

                                { user?.desired_job_title != "" && (
                                    <div className="job-preferences__item">
                                        <span className="job-preferences__label">Preferred Title:</span>
                                        <span className="job-preferences__value">{ user?.desired_job_title }</span>
                                    </div>
                                ) }

                                { user?.desired_salary != "" && (
                                    <div className="job-preferences__item">
                                        <span className="job-preferences__label">Expected Salary:</span>
                                        <span className="job-preferences__value">{ user?.desired_salary }</span>
                                    </div>
                                ) }

                                { user?.desired_cities != "" && (
                                    <div className="job-preferences__item">
                                        <span className="job-preferences__label">Preferred Cities:</span>
                                        <span className="job-preferences__value">{ user?.desired_cities }</span>
                                    </div>
                                ) }

                                { user?.desired_skills != "" && (
                                    <div className="job-preferences__item">
                                        <span className="job-preferences__label">Key Skills:</span>
                                        <span className="job-preferences__value job-preferences__skills">
                                            { user?.desired_skills.split(", ").map(function (skill, index) {
                                                return (
                                                    <span className="job-preferences__skill" key={ `skill-${ skill }-${ index }` }>{ skill }</span>
                                                );
                                            }) }
                                        </span>
                                    </div>
                                ) }
                            </div>
                        ) }

                        { user?.education?.length > 0 && (
                            <div className="section mt-5">
                                <h3>Education</h3>

                                <ul>
                                    { user.education.map(function (d, index) {
                                        return (
                                            <li key={ `education-${ index }` }>
                                                { d.degree } - { d.institute } ({ d.year })
                                            </li>
                                        );
                                    }) }
                                </ul>
                            </div>
                        ) }

                        { user?.experiences?.length > 0 && (
                            <div className="section">
                                <h3>Experience</h3>

                                <ul>
                                    { user?.experiences.map(function (d, index) {
                                        return (
                                            <li key={ `experience-${ index }` }>
                                                { d.designation } at { d.name } ({ d.from } - { d.to })
                                            </li>
                                        );
                                    }) }
                                </ul>
                            </div>
                        ) }

                        { user?.certificates?.length > 0 && (
                            <div className="section">
                                <h3>Certificates</h3>

                                <ul>
                                    { user?.certificates.map(function (d, index) {
                                        return (
                                            <li key={ `certificate-${ index }` }>
                                                { d.name } - { d.year }
                                            </li>
                                        );
                                    }) }
                                </ul>
                            </div>
                        ) }
                    </div>
                </div>
            </div>
        </>
    );
}

export default UserProfile;